<template>
    <section class="gmp-section gmp-mb-std">
        <div class="features-module">
            <div class="h-c-page">

                <div class="h-c-grid features-module__row">
                    <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 h-c-grid__col-l--order-1 features-module__content--left">
                        <h3 class="h-c-headline h-c-headline--one h-has-bottom-margin">
                            生产计划模块
                        </h3>
                        <p class="h-u-mb-std features-module__description">
                            根据订单汇总数据，允许管理人员手动指定生产计划，包括生产数量、生产顺序和生产时间等。
                            提供灵活的计划调整功能，管理人员可以实时调整生产计划以应对临时变化或紧急订单
                        </p>
                    </div>

                    <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 h-c-grid__col-l--order-2 features-module__content--right">
                        <div class="glue-zippy-set h-t-hercules ng-scope glue-is-mixed">
                            <div class="glue-zippy-toggle-all" data-g-action="expand all1">
                                <span class="h-c-expansion-panels__toggle-text h-c-expansion-panels__toggle-text--expanded">
                               展开全部
                            </span>
                                <span class="h-c-expansion-panels__toggle-text h-c-expansion-panels__toggle-text--collapsed">
                                折叠全部
                            </span>
                                <svg xmlns="http://www.w3.org/2000/svg"   class="h-c-icon h-c-icon--18px h-c-expansion-panels__toggle-circle" >
                                    <polyline points="0,0 4,4 8,0" style=" stroke:#177166; stroke-width:2" @click="expendAll(1)" />
                                </svg>
                            </div>

                            <ul class="h-c-expansion-panels__list">
                                <li class="glue-zippy glue-a-zippy--v-smooth-expand ng-isolate-scope glue-c-zippy ">
                                    <div class="glue-zippy-btn ng-isolate-scope glue-c-zippy__btn">
                                        <h4 class="h-c-expansion-panels__button-header">
                                            手动计划制定
                                        </h4>

                                        <svg xmlns="http://www.w3.org/2000/svg"   class="h-c-icon--18px h-c-expansion-panels__button-arrow" @click="addExpend(1,1)">
                                            <polyline points="0,0 7,7 14,0" style="fill:white;stroke:#1a73e8;stroke-width:3" />
                                        </svg>

                                    </div>

                                    <div class="glue-zippy-content ng-isolate-scope glue-c-zippy__content">
                                        <div class="glue-c-zippy__collapse-region glue-collapse-expanded" id="zippy-1-content1">
                                            <div class="glue-c-zippy__content-container">
                                                <p class="ng-scope">
                                                    管理人员可以根据订单汇总数据，手动制定每日或每批次的生产计划。
                                                </p>

                                            </div>

                                        </div>

                                    </div>

                                </li>
                                <li class="glue-zippy glue-a-zippy--v-smooth-expand ng-isolate-scope glue-c-zippy ">
                                    <div class="glue-zippy-btn ng-isolate-scope glue-c-zippy__btn">
                                        <h4 class="h-c-expansion-panels__button-header">
                                            实时计划调整
                                        </h4>

                                        <svg xmlns="http://www.w3.org/2000/svg"   class="h-c-icon--18px h-c-expansion-panels__button-arrow" @click="addExpend(2,1)">
                                            <polyline points="0,0 7,7 14,0" style="fill:white;stroke:#1a73e8;stroke-width:3" />
                                        </svg>

                                    </div>

                                    <div class="glue-zippy-content ng-isolate-scope glue-c-zippy__content">
                                        <div class="glue-c-zippy__collapse-region glue-collapse-expanded" id="zippy-2-content1">
                                            <div class="glue-c-zippy__content-container">
                                                <p class="ng-scope">
                                                    允许管理人员根据实际情况实时调整生产计划，确保生产的灵活性。
                                                </p>

                                            </div>

                                        </div>

                                    </div>

                                </li>

                            </ul>


                        </div>


                    </div>
                </div>




            </div>

        </div>


    </section>
</template>

<script>
    export default {
        name: "CK_features_module_two",
        methods: {

            expendAll(index){

                console.log(index)
                var expend = this.$('.gmp-mb-std').eq(index).find(".glue-zippy-toggle-all").attr('data-g-action');
                console.log(expend);
                // var expend = this.$('.glue-zippy-toggle-all').attr('data-g-action');
                var aaas =  this.$('.gmp-mb-std').eq(index).find('.h-c-expansion-panels__button-arrow');
                if(expend === 'expand all'+index){
                    console.log("towowowowoowoowowoowoowparenenetnntnntnn")
                    for(var i = 1; i < aaas.length +1 ; i++){
                        // var aaa =  this.$('.gmp-mb-std').eq(index).find('.h-c-expansion-panels__button-arrow')[i-1];
                        this.$('.gmp-mb-std').eq(index).find('.h-c-expansion-panels__button-arrow').eq([i-1]).parent().parent().addClass('glue-is-expanded');

                        // this.$('.gmp-mb-std').eq(index).parent().parent().addClass('glue-is-expanded');
                        this.$('.gmp-mb-std').eq(index).find('#zippy-'+i +'-content'+index).css({
                            "max-height": "100%",
                        })
                    }
                    this.$('.gmp-mb-std').eq(index).find('.glue-zippy-set').removeClass('glue-is-mixed').addClass('glue-is-expanded');
                    this.$('.gmp-mb-std').eq(index).find('.glue-zippy-toggle-all').attr("data-g-action","collapse all"+index)

                }else{
                    for(var j = 1; j < aaas.length +1 ; j++){
                        var aaa1 =  this.$('.gmp-mb-std').eq(index).find('.h-c-expansion-panels__button-arrow')[j-1];
                        this.$(aaa1).parent().parent().removeClass('glue-is-expanded');
                        this.$('#zippy-'+ j +'-content'+index).css({
                            "max-height": "0",
                        })
                    }
                    this.$('.gmp-mb-std').eq(index).find('.glue-zippy-set').addClass('glue-is-mixed').removeClass('glue-is-expanded');
                    this.$('.gmp-mb-std').eq(index).find('.glue-zippy-toggle-all').attr("data-g-action","expand all" +index)
                }
            },

            addExpend(index,which) {
                var aaa =  this.$('.gmp-mb-std').eq(which).find('.h-c-expansion-panels__button-arrow')[index-1];
                var fatherExpend = this.$('.gmp-mb-std').eq(which).find(aaa).parent().parent().is('.glue-is-expanded');
                if(fatherExpend){
                    this.$('.gmp-mb-std').eq(which).find('#zippy-'+index+'-content'+ which).css({
                        "max-height": "0",
                    })
                    this.$(aaa).parent().parent().removeClass('glue-is-expanded');
                    this.$('.glue-zippy-toggle-all').attr("data-g-action","expand all")
                    this.$('.glue-zippy-set').addClass('glue-is-mixed').removeClass('glue-is-expanded');

                }else{
                    this.$(aaa).parent().parent().addClass('glue-is-expanded');
                    this.$('#zippy-'+index+'-content' + which).css({
                        "max-height": "100%",
                    })
                }

            }


        },
    }
</script>

<style lang="less">


</style>